import { FormControl, MenuItem } from '@mui/material';
import { FC } from 'react';
import { WhiteBorderSMBSelect } from '../../../../helpers/styles';
type IClosingCalendarViewDropdown = {
  view: string;
  views: string[];
  onView: (view: string) => void;
};
export const ClosingCalendarViewDropdown: FC<IClosingCalendarViewDropdown> = ({
  view,
  views,
  onView
}) => {
  const handleViewChange = (view: string) => {
    onView(view);
  };

  const formatView = (view: string) => {
    switch (view) {
      case 'work_week':
        return 'Work Week';
      case 'month':
        return 'Month';
      case 'day':
        return 'Day';
      default:
        return 'No View';
    }
  };
  return (
    <FormControl fullWidth variant="outlined" size="small">
      <WhiteBorderSMBSelect
        name={'Views'}
        label={'View'}
        value={view}
        onChange={({ target: { value } }) => {
          handleViewChange(value);
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
      >
        {views.map((view, index) => {
          return (
            <MenuItem key={`closing-calendar-view`} value={view}>
              {formatView(view)}
            </MenuItem>
          );
        })}
      </WhiteBorderSMBSelect>
    </FormControl>
  );
};
